"use client";

import { useState, useEffect } from "react";

import clsx from "clsx";

import { Gallery21Block as Gallery21BlockType } from '@/payload-types';
import React from 'react';
import RichText from "@/components/RichText";
import { Carousel, CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Media } from "@/components/Media";
import { CMSLink } from "@/components/Link";
import FramerReveal from "@/components/framer-reveal-component";
import { getJustifyClass } from "@/blocks/Content/Component";
import { TypedLocale } from "payload";
import { cn } from "@/utilities/ui";

// type FeatureSection = NonNullable<Layout396BlockType['features']>[number]

export const Gallery21Block: React.FC<Gallery21BlockType
  & {
    id?: string,
    locale: TypedLocale
  }
> = ({
  locale, description, images, enableLink, links, theme
}) => {

    const [api, setApi] = useState<CarouselApi>();
    const [current, setCurrent] = useState(0);

    useEffect(() => {
      if (!api) {
        return;
      }
      setCurrent(api.selectedScrollSnap() + 1);
      api.on("select", () => {
        setCurrent(api.selectedScrollSnap() + 1);
      });
    }, [api]);

    // Get text format from richText if available
    const format = description?.root?.children[0]?.format as string | undefined;
    const justifyClass = getJustifyClass(format);

    return (
      <section data-theme={theme} className="bg-background py-16 md:py-24 lg:py-28">
        <div className="container">
          <div className=" mb-12 md:mb-18 lg:mb-20">
            {description && <RichText data={description} enableProse className="" />}
            {enableLink &&
              <FramerReveal>
                <div className={cn("mt-4 flex gap-x-4 md:mt-4", justifyClass)}>
                  {(links || []).map(({ link }: { link: any }, i: number) => (
                    <CMSLink key={i} {...link} />
                  ))}
                </div>
              </FramerReveal>
            }
          </div>

          <div className="">
            {/* for all available options: https://www.embla-carousel.com/api/options/ */}

            <Carousel
              setApi={setApi}
              opts={{
                loop: true,
                align:  locale === 'ar' ? 'end' : 'start',
                direction: locale === 'ar' ? 'rtl' : 'ltr',
              }}
            >
              <CarouselContent className="me-0">
                {images.map((image, index) => (
                  <CarouselItem key={index} className="basis-full pe-0 ps-6 md:basis-[37%] md:ps-8">
                    <Media resource={image} imgClassName="aspect-square size-full object-cover" />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <div className="rt-8 mt-8 flex items-center justify-between">
                <div className="mt-5 flex flex-wrap w-full items-start justify-start gap-1">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => api?.scrollTo(index)}
                      className={clsx("mx-[3px] inline-block size-2 rounded-full", {
                        "bg-card": current === index + 1,
                        "bg-card-1": current !== index + 1,
                      })}
                    />
                  ))}
                </div>
                <div className="flex items-end justify-end gap-2 md:gap-4">
                  <CarouselPrevious className={`static start-0 top-0 size-10 md:size-12 -translate-y-0 opacity-40 md:opacity-100 hover:opacity-100 transition-opacity ${locale === 'ar' ? 'order-1' : 'order-2'}`}/>
                  <CarouselNext className="static start-0 top-0 size-10 md:size-12 -translate-y-0 opacity-40 md:opacity-100 hover:opacity-100 transition-opacity" />
                </div>
              </div>
            </Carousel>

            {/* <Carousel
              setApi={setApi}
              opts={{
                loop: true,
                align: "start",
                direction: locale === 'ar' ? 'rtl' : 'ltr',
              }}
              className="overflow-hidden"
            >
              <div className="relative">
                <CarouselContent className="ms-0">
                  {images.map((image, index) => (
                    <CarouselItem key={index} className="px-0 md:px-16 lg:px-28">
                      <div className="relative w-full pt-[66.66%] overflow-hidden">
                        <Media resource={image} imgClassName="absolute inset-0 size-full object-cover" />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="hidden md:flex md:size-12 lg:size-14 !left-0" />
                <CarouselNext className="hidden md:flex md:size-12 lg:size-14 !right-0" />
              </div>
              <div className="mt-[30px] flex items-center justify-center md:mt-[46px]">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => api?.scrollTo(index)}
                    className={clsx("relative mx-[3px] inline-block size-2 rounded-full", {
                      "bg-accent-2": current === index + 1,
                      "bg-primary-1": current !== index + 1,
                    })}
                  />
                ))}
              </div>
            </Carousel> */}

          </div>
        </div>
      </section>
    );
  };
